import { Text } from 'platform-components/common';
import React from 'react';

import './spec-course-lesson-view__stub-description.scss';

interface Props {
    id: string;
}

export const SpecCourseLessonViewStubDescription = React.memo(({ id }: Props) => {
    return (
        <div className="spec-course-lesson-view__stub-description">
            <Text id={id} size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} />
        </div>
    );
});
